/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ButtonTokenWethRouter,
  ButtonTokenWethRouterInterface,
} from "../ButtonTokenWethRouter";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "buttonToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "buttonToken",
        type: "address",
      },
    ],
    name: "burnAll",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "buttonToken",
        type: "address",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "weth",
    outputs: [
      {
        internalType: "contract IWETH9",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type ButtonTokenWethRouterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ButtonTokenWethRouterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ButtonTokenWethRouter__factory extends ContractFactory {
  constructor(...args: ButtonTokenWethRouterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _weth: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ButtonTokenWethRouter> {
    return super.deploy(
      _weth,
      overrides || {}
    ) as Promise<ButtonTokenWethRouter>;
  }
  getDeployTransaction(
    _weth: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_weth, overrides || {});
  }
  attach(address: string): ButtonTokenWethRouter {
    return super.attach(address) as ButtonTokenWethRouter;
  }
  connect(signer: Signer): ButtonTokenWethRouter__factory {
    return super.connect(signer) as ButtonTokenWethRouter__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ButtonTokenWethRouterInterface {
    return new utils.Interface(_abi) as ButtonTokenWethRouterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ButtonTokenWethRouter {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ButtonTokenWethRouter;
  }
}
